<template>
    <div :class="stepWrapperClasses" :key="step">
        <h5 class="step-field-heading"><span class="las back" v-if="isNotFirstStep" @click="prevStep()"><img src="../../assets/arrow_back-24px.svg" ></span>
        <span class="step-field-heading-text">Team Member</span></h5>
        <div v-if="teamMembersLoaded" class="step-fields-body">
            <div class="team-member-wrapper step-fields-list-box">
                <team-member-row
                v-for="item in stepData.teamMember"
                :value="value"
                :item="item"
                :key="item.id"
                v-on:filled-out="addTeamMemberBookingDetails($event)"></team-member-row>
            </div>
        </div>
        <div v-else class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex';
  import TeamMemberRow from './TeamMemberRow';
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    props: {
        field: {},
        details: {},
        value: '',
        index: '',
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'nextStep',
          'prevStep',
          'setStepData'// referenced in the mixin
        ]),
        addTeamMemberBookingDetails(value) {
            let teamMember = this.getTeamMemberById(value);
            this.addBookingDetails({
                'type' : 'teamMember',
                'details' : teamMember
            });
            this.nextStep();
            this.$emit('filled-out',teamMember);
        },
        getTeamMemberById(id) {
            let teamMembers = this.stepData.teamMember.filter(teamMember => teamMember.id == id);
            if (teamMembers[0]) {
                return teamMembers[0];
            } else {
                return {};
            }
        },
        async loadTeamMembers() {
            if (this.bookingDetails.schedulingDateAndTime.employees) {
                this.setCurrentStepData(this.bookingDetails.schedulingDateAndTime.employees);
            } else {
                this.setCurrentStepData([]);
            }
        },
        test() {
            return this.$vssWidth < 415;
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
        ]),
        ...mapState('scheduling', { step: 'step', stepData: 'stepData', bookingDetails: 'bookingDetails' }),
        teamMembersLoaded() {
            return this.stepData.teamMember !== '';
        }
    },
    created() {
        if (this.stepData.teamMember === false) {
            this.setCurrentStepData('');
            this.prevStep();
        } else {
            this.loadTeamMembers();
            if (!this.teamMembersLoaded || this.stepData.teamMember.length == 0) {
                this.setCurrentStepData(false);
                this.nextStep();
            }
        }
    },
    components: {
        TeamMemberRow
    }
  };
</script>
